import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import './style.css';
import LangaugeMenu from './LanguageMenu';
import { parseCompanyStyle } from 'utils';

export default function Footer(props) {
  const today = new Date();
  const {
    theme,
    privacyUrl,
    aboutUsUrl,
  } = props;

  const companyStyle = parseCompanyStyle(theme.footerColor, theme.footerFontColor);
  const companyStyleColor = { color: companyStyle.color };
  return (
    <footer
      className="footer"
      style={companyStyle}
    >
      <div className="container">
        <div className="col-sm-3 text-center">
          <LangaugeMenu {...props}/>
        </div>
        <div className="col-sm-6">
          <div className="footer__copyright">
            <span className="footer__copyright-company" style={companyStyleColor}>
              Copyright © {today.getFullYear()} MAYO Human Capital Inc. All rights reserved.
            </span>
          </div>
        </div>
        <div className="col-sm-3">
          <div className="footer__copyright">
            <a
              className="footer__copyright-link"
              style={companyStyleColor}
              href={privacyUrl}
              onClick={(event) => {
                if (props.leaveWarnHandler) {
                  const nextpath = event.target.pathname || event.target.parentElement.pathname;
                  props.leaveWarnHandler(() => {
                    window.location.href = nextpath;
                  });
                  event.preventDefault();
                }
              }}
            >
              <FormattedMessage id="SH_PrivacyPolicy" defaultMessage="隱私權政策" />
            </a>
            <span className="footer__copyright-divider" style={companyStyleColor}>/</span>
            <a
              className="footer__copyright-link"
              style={companyStyleColor}
              href={aboutUsUrl}
              target="blank"
            >
              About Us
            </a>
          </div>
        </div>
        {/* <div className="footer__copyright">


        </div> */}
      </div>
    </footer>
  );
}

Footer.propTypes = {
  theme: PropTypes.object,
  privacyUrl: PropTypes.string,
  aboutUsUrl: PropTypes.string,
};

Footer.defaultProps = {
  theme: {
    headerColor: '#008bcd',
    headerFontColor: '#FFF',
    footerColor: '#008bcd',
    footerFontColor: '#FFF',
    footerHoverFontColor: '#FFF',
  },
  privacyUrl: '/privacy',
  aboutUsUrl: 'https://www.mayohr.com/',
};



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/420/s/Tube.Frontend/src/components/Footer/index.js
 **/